import CategoryCard from "components/general/Card/CategoryCard";
import CategoryCardList from "components/general/CategoryCardList";
import Container from "components/general/Container";
import PageHeader from "components/general/Headers/PageHeader";
import PageLoader from "components/general/PageLoader";
import ScrollContainer from "components/general/ScrollContainer";
import Section from "components/general/Section";
import Seo from "components/general/Seo";
import { Box, FlatList, H2, SafeAreaView, View } from "components/ui";
import { useAuth } from "components/clerk";
import React from "react";
import { Platform } from "react-native";
import { useGetCategoryQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
import BannerImageSlider from "components/general/BannerImageSlider";
export default function Page() {
	const { data: baseData, isLoading, isFetching, isError, error, currentData } = useGetCategoryQuery();
	const isMobile = useIsMobile();
	const { isSignedIn } = useAuth();

	const data = baseData?.filter((item) => item.categoryType === "Products");
	if (isLoading) {
		return (
			<Box minHeight={300}>
				<PageLoader />
			</Box>
		);
	}
	if (isMobile && Platform.OS !== "web") {
		return (
			<SafeAreaView>
				<Seo title="Products | Abconet" description="Explore the complete list of available products, including specifications and pricing." />
				<FlatList
					ListHeaderComponent={() => (
						<View>
							<H2>Products</H2>
						</View>
					)}
					keyExtractor={(item: any) => item.slug}
					data={data ?? []}
					numColumns={3}
					key="_1"
					columnWrapperStyle={{ justifyContent: "space-between" }}
					renderItem={({ item }: any) => (
						<View
							sx={{
								flex: 1 / 2,
							}}
						>
							<CategoryCard category={item} />
						</View>
					)}
				/>
			</SafeAreaView>
		);
	}
	return (
		<ScrollContainer>
			<Seo title="Products | Abconet" description="Explore a wide range of cleaning products and solutions designed to meet the needs of businesses across various industries." />
			<Container>
				{isSignedIn ? (
					<PageHeader
						title={"Products"}
						description="At Abco Products, we offer a comprehensive range of high-quality cleaning solutions, consumables, and environmental products designed to meet the needs of businesses across various industries. Our products are carefully selected to enhance efficiency, improve hygiene standards, and support sustainable cleaning practices. Whether you need premium cleaning chemicals, durable consumables, or eco-friendly alternatives, we provide reliable solutions that help you maintain a spotless and safe environment. Explore our full range and discover how Abco can support your business with innovative and effective cleaning products."
					/>
				) : (
					<BannerImageSlider type={"products"} />
				)}
				<Section gap={24}>
					<H2>Browse products</H2>
					<CategoryCardList list={data} />
				</Section>
			</Container>
		</ScrollContainer>
	);
}
